import hexRgb from 'hex-rgb'

const removeAll = async (showcase, poiList, isHide = false) => {
  // Wait for Matterport to be completely ready before rendering POIs
  await new Promise((resolve) => setTimeout(resolve, 2000));

  console.log('[POI Icons - Showcase] Starting POI rendering for', poiList?.length, 'POIs');

  showcase.Tag.toggleNavControls(false)
  showcase.Tag.toggleSharing(false);
  showcase.Tag.toggleDocking(false);
  let tag = await showcase?.Mattertag.getData()
  tag?.forEach((origMatt => {
    showcase?.Mattertag.remove(origMatt.sid)
  }))
  let poiRender = poiList?.map(async poi => {
    let colorToRgb = hexRgb(poi?.backgroundColor)
    let r = colorToRgb.red / 255
    let g = colorToRgb.green / 255
    let b = colorToRgb.blue / 255
    const tag = {
      label: poi?.name || '',
      description: '',
      anchorPosition: { x: poi.x, y: poi.y, z: poi.z },
      stemVector: poi?.stemVector || { x: 0, y: 0, z: 0 },
      color: { r, g, b },
    }
    let matPoi = await showcase.Mattertag.add([tag])
    poi.matterPortId = matPoi[0]

    // Small delay to ensure tag is registered in SDK
    await new Promise(resolve => setTimeout(resolve, 100));

    await showcase?.Tag.allowAction(matPoi[0], {
      navigating: true,
      opening: true,
    })
    if (poi?.icon) {
      let math = Math.random()?.toFixed(3)
      const iconId = `${matPoi[0]}-${math}`;

      console.log('[POI Icons - Showcase] Registering icon for', poi?.name, 'with URL:', poi?.icon);

      // Fire-and-forget - don't await, let it complete in background
      showcase.Mattertag.registerIcon(iconId, poi?.icon)
        .then(res => {
          console.log('[POI Icons - Showcase] ✓ Registered icon for', poi?.name);
          return showcase.Mattertag.editIcon(matPoi[0], iconId);
        })
        .then(res => {
          console.log('[POI Icons - Showcase] ✓ Applied icon to tag for', poi?.name);
        })
        .catch(err => {
          console.error('[POI Icons - Showcase] ✗ Error with icon for', poi?.name, ':', err);
          console.error('[POI Icons - Showcase] ✗ Failed URL:', poi?.icon);
        });
    } else {
      console.log('[POI Icons - Showcase] No icon specified for', poi?.name);
    }

    // Await opacity and stem edits to ensure tag is ready
    if (poi?.enabled) {
      let opacity = poi?.opacity / 100
      await showcase.Mattertag.editOpacity(matPoi[0], opacity)
    } else {
      await showcase.Mattertag.editOpacity(matPoi[0], 0)
    }
    await showcase.Mattertag.editStem(matPoi[0],
      {
        stemVisible: poi?.stemVisible,
        stemHeight: poi?.stemLength
      }
    )
    return poi
  })
  return await Promise.all(poiRender)
}

const fullRemove = async (showcase) => {
  let tag = await showcase?.Mattertag.getData()
  tag?.forEach((origMatt => {
    showcase?.Mattertag.remove(origMatt.sid)
  }))
}

const removeOne = async (showcase, id) => {
  await showcase?.Mattertag.editOpacity(id, 0)
  await showcase.Tag.allowAction(id, {
    navigating: false,
    opening: false,
  })
}

const addTag = async (showcase, id) => {
  await showcase?.Mattertag.editOpacity(id, 1)
  await showcase.Tag.allowAction(id, {
    navigating: true,
    opening: true,
  })
}

const allPrevent = async (showcase) => {
  let tag = await showcase?.Mattertag.getData()
  await Promise.all(tag?.forEach((origMatt => {
    showcase?.Mattertag.editOpacity(origMatt.sid, 0)
    showcase.Tag.allowAction(origMatt.sid, {
      navigating: false,
      opening: false,
    })
  })))
}

const allDisplay = async (showcase) => {
  let tag = await showcase?.Mattertag.getData()
  await Promise.all(tag?.forEach((origMatt => {
    showcase?.Mattertag.editOpacity(origMatt.sid, 1)
    showcase.Tag.allowAction(origMatt.sid, {
      navigating: true,
      opening: true,
    })
  })))
}


export { removeAll, fullRemove, removeOne, addTag, allPrevent, allDisplay }
